import { Action, ActionSubject, TrackAction, TrackActionSubject } from '../new-analytics-types';
import type { ScreenEvent, TrackEvent, UIEvent } from '../new-analytics-types';

const source = 'userProfileSidepanel';
export const unifiedUserProfileSidePanelEvents = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/5144024035/Analytics+Spec+UP+M1.5',
  screen: {
    unifiedUserProfileSidepanelScreen: (attributes?: { userId: string; status: string | undefined; accountTag: string }): ScreenEvent => ({
      data: {
        name: 'userProfileSidepanel',
        attributes: {
          userId: attributes?.userId ?? '',
          userStatus: attributes?.status ?? '',
          userType: attributes?.accountTag ?? '',
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92645',
    }),
  },
  track: {
    unifiedUserProfileSidepanelUserUpdated: (attributes?: { userId: string }): TrackEvent => ({
      data: {
        action: TrackAction.Updated,
        actionSubject: TrackActionSubject.SidepanelProfile,
        source,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92811',
    }),
  },
  ui: {
    unifiedUserProfileSidepanelClosed: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'userProfileSidepanelClose',
        source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92812',
    }),
    unifiedUserProfileSidepanelViewFullProfileClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'userProfileSidepanelViewFullProfile',
        source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92813',
    }),
    unifiedUserProfileSidepanelAddGroupsClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'userProfileSidepanelAddGroups',
        source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92814',
    }),
    unifiedUserProfileSidepanelAddAppsClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'userProfileSidepanelAddApps',
        source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92815',
    }),
    unifiedUserProfileSidepanelViewMoreGroupsClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'userProfileSidepanelViewMoreGroups',
        source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92816',
    }),
    unifiedUserProfileSidepanelViewMoreAppsClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'userProfileSidepanelViewMoreApps',
        source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92817',
    }),
  },
};
